import { useState, useCallback, type ReactNode } from "react";
import { IntakeContext, type PrescreenData, type IntakeState } from "./intake-context-value";

export type { PrescreenData, IntakeSegment, IntakeState } from "./intake-context-value";

export function IntakeProvider({ children }: { children: ReactNode }) {
  const [token, setToken] = useState<string | null>(null);
  const [prescreen, setPrescreen] = useState<PrescreenData | null>(null);
  const [prescreenResult, setPrescreenResult] = useState<IntakeState["prescreenResult"]>(null);
  const [consentVersion, setConsentVersion] = useState<string | null>(null);
  const [completeResult, setCompleteResult] = useState<IntakeState["completeResult"]>(null);

  const setTokenCb = useCallback((t: string) => setToken(t), []);
  const setPrescreenCb = useCallback((p: PrescreenData) => setPrescreen(p), []);
  const setPrescreenResultCb = useCallback((r: IntakeState["prescreenResult"]) => setPrescreenResult(r), []);
  const setConsentVersionCb = useCallback((v: string) => setConsentVersion(v), []);
  const setCompleteResultCb = useCallback((r: IntakeState["completeResult"]) => setCompleteResult(r), []);

  return (
    <IntakeContext.Provider
      value={{
        token,
        prescreen,
        prescreenResult,
        consentVersion,
        completeResult,
        setToken: setTokenCb,
        setPrescreen: setPrescreenCb,
        setPrescreenResult: setPrescreenResultCb,
        setConsentVersion: setConsentVersionCb,
        setCompleteResult: setCompleteResultCb,
      }}
    >
      {children}
    </IntakeContext.Provider>
  );
}
